import React, { ReactElement } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { HashLink } from 'react-router-hash-link';

interface Props {
  // You can add props here if needed
}

export default function Header({ }: Props): ReactElement {
  // Get current location to check if we're on the about page
  const location = useLocation();
  const isAboutPage = location.pathname === '/about';

  return (
    <header className="relative bg-white h-[100px] min-h-[100px] mt-5">
      <div className="max-w-5xl mx-auto px-4 h-full">
        <div className="w-full h-full opacity-0 animate-fade-in-up animation-delay-50">
          <div className="flex items-start justify-between h-full">
            <div className="flex items-center">
              <div className="flex flex-col sm:flex-row items-baseline">
              <Link to="/" className="font-bold text-3xl md:mb-0">
                <span className="inline md:inline-block">Christophe</span>
                <span className="hidden md:inline-block md:ml-2"> van Eerdt</span>
                <span className="inline md:hidden"><br />van Eerdt</span>
              </Link>
              </div>
            </div>
            
<div className="flex flex-col items-center md:items-center">
  {isAboutPage ? (
    <div className="flex items-center justify-center md:flex-col md:items-center">
      <Link to="/" className="px-4 text-sm underline md:mt-2">Home</Link>
    </div>
  ) : (
    <>
      <img 
        src="/assets/Christophe van Eerdt Product Strategist.png" 
        alt="Christophe van Eerdt - Venture" 
        className="w-16 h-16 object-cover rotate-12 md:hidden" 
      />
      <Link to="/about" className="mt-2 px-4 text-sm underline">About me</Link>
    </>
  )}
</div>
          </div>
        </div>
      </div>
    </header>
  );
}